import { useState, useEffect } from "react";
import logoBlack from "/src/assets/images/logo-black.png";
import whatsappIcon from "/src/assets/icons/whatsapp.svg";

/**
 * Cabeçalho fixo da landing page
 * Aparece quando o usuário rola a página
 */
export function Header() {
    // Estado para controlar a visibilidade do header
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Função para detectar scroll da página
        const handleScroll = () => {
            // Mostra o header após rolar 100px
            setIsVisible(window.scrollY > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <header
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isVisible
                ? "before:content-[''] before:absolute before:inset-0 before:bg-gradient-to-b before:from-white/10 before:to-transparent before:pointer-events-none bg-slate-950/40 backdrop-blur-2xl border-b border-white/10 py-3 shadow-[0_8px_32px_rgba(0,0,0,0.3),inset_0_1px_0_rgba(255,255,255,0.1)]"
                : "bg-transparent py-6"
                }`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between">
                    {/* Logo da Agência Gens */}
                    <a href="#" className="flex items-center gap-2">
                        <img src={logoBlack} alt="Agência Gens" className="h-12 w-auto object-contain" />
                    </a>

                    {/* Botão CTA no header - Link direto para WhatsApp */}
                    <a
                        href="https://api.whatsapp.com/send/?phone=5583999004689&text=Olá%2C+gostaria+de+informações+sobre+o+tráfego+pago+e+inteligência+artificial&type=phone_number&app_absent=0"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-brand-400 hover:bg-brand-500 text-slate-950 px-6 py-2 rounded-full font-semibold transition-all duration-300 text-sm sm:text-base btn-glow shadow-[0_0_20px_rgba(185,255,102,0.3)]"
                    >
                        <img src={whatsappIcon} alt="" className="w-4 h-4" />
                        Quero minha vaga
                    </a>
                </div>
            </div>
        </header>
    );
}
